export interface FooterProps {
  isVisible: boolean
}

export const useFooter = (props: FooterProps) => {
  return {
    ...props,
  }
}
